import _ from 'lodash';
import appOptions from '../helpers/appOptions';
import config from '../config';
import {isNativeMobileAndroid, isNativeMobileIOS} from '../helpers/utility';

let logger = {
    log(logData, async = true) {
        const environment = appOptions.get('environment');

        if (
            ['dev', 'development', 'test', 'stage'].indexOf(environment) !== -1
        ) {
            // eslint-disable-next-line no-console
            console.info(logData);
        }

        try {
            let data = this.format(logData);

            $.ajax({
                async,
                contentType: 'application/json',
                data: JSON.stringify(data),
                dataType: 'json',
                type: 'POST',
                url: '/td/clientLogging/event',
            });
        } catch (error) {
            // log to Console conditionally
            if (
                typeof environment !== 'undefined' &&
                environment.toLowerCase() !== 'prd' &&
                typeof console !== 'undefined'
            ) {
                // eslint-disable-next-line no-console
                console.log(`Error sending EventRequest: ${error} ${logData}`);
            }
        }
    },
    format(logData) {
        let message = logData;

        if (_.isObject(logData)) {
            message = JSON.stringify(logData);
        }

        // Adding extra info in message for native request monitoring from Splunk
        if (!_.isUndefined(message)) {
            if (isNativeMobileAndroid()) {
                message = message.concat(' nativeOS=Android');
            } else if (isNativeMobileIOS()) {
                message = message.concat(' nativeOS=iOS');
            } else {
                message = message.concat(' nativeOS=undefined');
            }
            message = message.concat(
                ' checkoutType=',
                appOptions.get('checkoutType')
            );
        }

        const data = {
            logs: [
                {
                    message,
                    userAgent: config.userAgent,
                    type: 'info',
                    url: window.location.href,
                },
            ],
        };

        return data;
    },
};

export default logger;
